import { useEffect } from 'react';

/**
 * 채팅방의 position bottom으로 이동
 */
/* const useSelectChatBottom = () => {
  useEffect(() => () => {
      document.querySelector('._message_layout').scrollTop = document.querySelector('._message_layout').scrollHeight;
   document.getElementById('scrollToElement').scrollTop = document.getElementById('scrollToElement').scrollHeight;
  })

};  */

const useSelectChatBottom = () => {
  useEffect(() => () => {
    const msgTop = document.querySelectorAll('._customer_message_div');
    const messageList = document.querySelectorAll('.scroll_style_messenger > div');
    if (messageList.length > 1) {
      if (messageList[messageList.length - 2].getAttribute('name').includes('bot_')) {
        document.getElementById('scrollToElement').scrollTo({
          top: document.getElementById('scrollToElement').scrollHeight,
          behavior: 'smooth',
        });
      } else if (msgTop.length > 0) {
        document.getElementById('scrollToElement').scrollTo({
          top: msgTop[msgTop.length - 1].offsetTop - 20,
          behavior: 'smooth',
        });
      }
    } else {
      document.getElementById('scrollToElement').scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  });
};

export default useSelectChatBottom;

